<div class="container-fluid">
    <div class="main-content" style="z-index:4">
      <nb-layout>
       <nb-layout-column>
           <app-header style="width:100%"></app-header>
           <router-outlet></router-outlet>
        </nb-layout-column>
      </nb-layout>
    </div>
</div>